import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/services/authentication.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
,
  standalone: false
})
export class DashboardComponent implements OnInit {
  readOnlyUser: boolean = false;
  viewSites: boolean = false;
  viewMonitos: boolean = false;

  viewDashboard: boolean = false;
  viewSettings: boolean = false;
  currentuser: any;
  constructor(
    public authService: AuthenticationService
  ) { }

  ngOnInit(): void {
    this.currentuser = this.authService.currentUserValue;
    document.getElementById("mycolor").style.color = "red";
    if (this.currentuser) {
      if (this.currentuser['privileges'] && this.currentuser['privileges'].length > 0) {
        for (let i = 0; i < this.currentuser['privileges'].length; i++) {
          if (this.currentuser['privileges'][i].toLowerCase() === 'view sites') {
            this.viewSites = true;
          }
          if (this.currentuser['privileges'][i].toLowerCase() === 'view monitors') {
            this.viewMonitos = true;
          }
          if (this.currentuser['privileges'][i].toLowerCase() === 'view dashboard') {
            this.viewDashboard = true;
          }
          if (this.currentuser['privileges'][i].toLowerCase() === 'view zendesk-comments') {
            this.viewDashboard = true;
          }
          if (this.currentuser['privileges'][i].toLowerCase() === 'view settings') {
            this.viewSettings = true;
          }
        }
      }
    }
  }

}
